import type { ReviewFeedbackItem, SpeakerKind } from '@/types/review';

const STATUS_LABELS: Record<string, string> = {
  ACTION: '改善提案',
  ISSUE: '要改善',
  CHECK: '要確認',
  PASS: '問題なし',
  GOOD: '良好',
};

const INTERNAL_TERM_REPLACEMENTS: Array<[RegExp, string]> = [
  [/\bFacilitator\b/g, 'コーチ'],
  [/\bfacilitator\b/g, 'コーチ'],
  [/\bParticipant\b/g, '参加者'],
  [/\bparticipant\b/g, '参加者'],
  [/\bTranscript\b/g, '文字起こし'],
  [/\btranscript\b/g, '文字起こし'],
  [/\bISSUE\b/g, '改善が必要な点'],
  [/\bCHECK\b/g, '改善が必要な点'],
  [/\bPASS\b/g, '問題なし'],
  [/\bGOOD\b/g, '良好'],
  [/【\s*型準拠\s*】/g, ''],
  [/【\s*意味伝達\s*】/g, ''],
  [/型準拠軸/g, ''],
  [/意味伝達軸/g, ''],
  [/型準拠/g, ''],
  [/意味伝達/g, ''],
  [/script axis/g, ''],
  [/semantic axis/g, ''],
];

export function speakerDisplayLabel(speaker: SpeakerKind | string | null | undefined): string {
  return speaker === 'facilitator' ? 'コーチ' : '参加者';
}

export function reviewStatusDisplayLabel(status: string | null | undefined): string {
  const normalized = String(status ?? '').trim().toUpperCase();
  return STATUS_LABELS[normalized] ?? (status ? normalizeReviewDisplayText(String(status)) : '未判定');
}

export function axisDisplayLabel(axis: ReviewFeedbackItem['axis'] | string): string {
  if (axis === 'script') return '進め方';
  if (axis === 'meaning' || axis === 'semantic') return '伝わり方';
  return '参考';
}

export function normalizeReviewDisplayText(value: string | null | undefined): string {
  let text = String(value ?? '');
  for (const [pattern, replacement] of INTERNAL_TERM_REPLACEMENTS) {
    text = text.replace(pattern, replacement);
  }
  return text
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
